import lodash from "lodash-es";

import { get, post } from "@/common/request";
import { ProtableRequestProps } from "@/common/types";

import { RequestData, ResponseData, UserItem } from "./types";

export const tableRequest: ProtableRequestProps<UserItem> = async ({
  current,
  ...params
}) => {
  const { list, total } = await post<RequestData, ResponseData>(
    "/app/user/pageQuery",
    { ...lodash.pickBy(params), pageNumber: current },
  );
  return { data: list, success: true, total };
};

export const deleteRecord = async (id: string | number) =>
  await get(`/user/delete/${id}`);
